import { CommonModule } from '@angular/common';
import { ForbiddenPageComponent } from './components/forbidden-page/forbidden-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedUtilsModule } from '@jissu-public/shared/utils';
import { UnauthorizedPageComponent } from './components/unauthorized-page/unauthorized-page.component';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { TranslateModule } from '@ngx-translate/core';
import { SortableColumnDirective } from './directives/sortable-column.directive';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { CookiesBannerComponent } from './components/cookies-banner/cookies-banner.component';
import { SablonaObsahComponent } from './components/sablona-obsah/sablona-obsah.component';

@NgModule({
  declarations: [
    ForbiddenPageComponent,
    UnauthorizedPageComponent,
    BreadcrumbsComponent,
    SortableColumnDirective,
    PaginatorComponent,
    CookiesBannerComponent,
    SablonaObsahComponent,
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, SharedUtilsModule, TranslateModule],
  exports: [
    ForbiddenPageComponent,
    UnauthorizedPageComponent,
    BreadcrumbsComponent,
    SortableColumnDirective,
    PaginatorComponent,
    CookiesBannerComponent,
    SablonaObsahComponent,
  ],
})
export class SharedUiLibModule {}
